export const nav_carbon = "Carbon";
export const nav_builds = "Projekty";
export const nav_atelier = "Atelier";
export const nav_models = "Modele";
export const nav_process = "Proces";
export const nav_contact = "Kontakt";
export const nav_about = "O Nas";
export const nav_cta = "Rozpocznij Budowę";

export const hero_tagline = "Wykonane z Węgla. Zbudowane Bez Kompromisów.";
export const hero_cta_primary = "Skonfiguruj Swój";
export const hero_cta_secondary = "Odkryj Modele";
export const hero_scroll = "Przewiń, Aby Odkryć";
export const hero_video_toggle = "Wideo";
export const hero_slides_toggle = "Slajdy";
export const hero_mute = "Wycisz";
export const hero_unmute = "Włącz Dźwięk";

export const manifest_title = "Manifest Veragua";
export const manifest_text = "Projektujemy poza konwencją. Każdy komponent jest analizowany, każda powierzchnia dopracowana. Włókno węglowe to nie wybór materiału—to nasza podstawa. Wydajność to nie funkcja—to nasza obsesja. Nie podążamy za trendami. Wyznaczamy standardy.";

export const manifest_line1 = "To nie jest stylizacja.";
export const manifest_line2 = "To jest rekonstrukcja.";
export const manifest_line3 = "Skanowanie 3D. Inżynieria. Wykończenie ręczne.";

export const carbon_title = "Dział Carbon";
export const carbon_subtitle = "Doskonałość Inżynieryjna";
export const carbon_desc = "Nasz Dział Carbon reprezentuje szczyt lekkiej inżynierii. Każdy komponent jest skrupulatnie wykonany z włókna węglowego klasy lotniczej, redukując wagę przy jednoczesnej maksymalizacji integralności strukturalnej i wydajności.";
export const carbon_cta = "Poznaj Technologię Carbon";

export const carbon_division_label = "DZIAŁ 01";
export const carbon_division_title1 = "CARBON";
export const carbon_division_title2 = "DIVISION";
export const carbon_division_desc = "Każdy komponent jest projektowany od surowego kompozytu do gotowej części we własnym zakresie. Bez outsourcingu. Bez kompromisów.";
export const carbon_custom_config = "Niestandardowe konfiguracje dostępne dla wszystkich platform.";
export const carbon_request_build = "ZAMÓW NIESTANDARDOWY BUILD";
export const carbon_view_details = "SZCZEGÓŁY";
export const carbon_materials_label = "MATERIAŁY";
export const carbon_process_label = "PROCES";

export const builds_title = "Sygnaturowe Projekty";
export const builds_subtitle = "Arcydzieła w Ruchu";
export const builds_view = "Zobacz Projekt";

export const builds_limited_series = "Seria Limitowana";
export const builds_each_build = "Każdy build to wyjątkowe dzieło. Zaprojektowane do perfekcji. Limitowane do dziesięciu.";
export const builds_view_project = "ZOBACZ PROJEKT";

export const engineering_title = "Szczegóły Inżynieryjne";
export const engineering_subtitle = "Precyzja w Każdym Komponencie";
export const engineering_tab_chassis = "Podwozie";
export const engineering_tab_aero = "Aerodynamika";
export const engineering_tab_power = "Napęd";
export const engineering_chassis_title = "Podwozie Monocoque z Węgla";
export const engineering_chassis_desc = "Nasze autorskie podwozie monocoque z włókna węglowego zapewnia wyjątkową sztywność przy minimalnej wadze. Każda warstwa jest precyzyjnie zaprojektowana dla optymalnego stosunku wytrzymałości do masy.";
export const engineering_aero_title = "Aktywna Aerodynamika";
export const engineering_aero_desc = "Inteligentne systemy aerodynamiczne dostosowują się w czasie rzeczywistym, optymalizując docisk i opór dla każdych warunków jazdy. Testowane w tunelu aerodynamicznym, sprawdzone na torze.";
export const engineering_power_title = "Napęd Hybrydowy";
export const engineering_power_desc = "Zaawansowana technologia hybrydowa łączy surową moc z efektywnością. Silniki elektryczne zapewniają natychmiastowy moment obrotowy, podczas gdy silnik spalinowy dostarcza trwałą wydajność.";

export const engineering_technical_spec = "Specyfikacja Techniczna";
export const engineering_headline1 = "Zaprojektowane z";
export const engineering_headline2 = "dokładnymi tolerancjami.";
export const engineering_body = "Każda liczba poniżej jest zmierzona, nie szacowana. Nasz proces opiera się na metodologii klasy lotniczej zastosowanej do budowy węglowych elementów samochodowych.";
export const engineering_process_overview = "Przegląd Procesu";
export const engineering_docs_note = "Pełna dokumentacja techniczna dostępna na zapytanie projektowe";
export const engineering_request_docs = "Zamów Dokumentację";

export const atelier_title = "Atelier Wnętrz";
export const atelier_subtitle = "Rzemiosło na Zamówienie";
export const atelier_desc = "Nasze Atelier Wnętrz przekształca kabiny w spersonalizowane sanktuaria. Każdy szew, każda powierzchnia, każdy detal jest dostosowany do Twojej wizji. Od ręcznie wybranych skór po niestandardowe sploty węglowe, tworzymy wnętrza odzwierciedlające Twoją indywidualność.";
export const atelier_cta = "Zaprojektuj Swoje Wnętrze";

export const atelier_craftsmanship_label = "Rzemiosło";
export const atelier_headline = "WNĘTRZE / ATELIER";
export const atelier_body = "Gdzie materiały spotykają mistrzostwo. Każdy szew, każda powierzchnia, zaprojektowane dla perfekcji.";
export const atelier_material_label = "MATERIAŁ";
export const atelier_our_services = "NASZE USŁUGI";
export const atelier_schedule = "UMÓW KONSULTACJĘ";

export const performance_title = "Linia Wydajności";
export const performance_subtitle = "Moc Bez Kompromisów";
export const performance_spec_power = "Moc Wyjściowa";
export const performance_spec_torque = "Maksymalny Moment";
export const performance_spec_weight = "Masa Własna";
export const performance_spec_acceleration = "0-100 km/h";
export const performance_spec_top_speed = "Prędkość Maksymalna";
export const performance_cta = "Zobacz Specyfikacje";

export const performance_label = "Wydajność";
export const performance_headline1 = "ZAPROJEKTOWANA";
export const performance_headline2 = "DYNAMIKA";

export const models_title = "Galeria Modeli";
export const models_subtitle = "Odkryj Naszą Kolekcję";
export const models_search_placeholder = "Szukaj modeli...";
export const models_filter_all = "Wszystkie Modele";
export const models_filter_hypercar = "Hypercar";
export const models_filter_gt = "GT";
export const models_filter_roadster = "Roadster";
export const models_filter_limited = "Edycja Limitowana";
export const models_view = "Zobacz Szczegóły";
export const models_configure = "Konfiguruj";

export const models_config_label = "Konfiguracja · Modele";
export const models_headline = "MODELE / GALERIA";
export const models_body = "Wybierz swój pojazd bazowy i skonfiguruj go zgodnie ze swoją wizją. Każdy projekt jest realizowany indywidualnie.";
export const models_available = "modeli dostępnych do konfiguracji";
export const models_ask_another = "ZAPYTAJ O INNY MODEL";
export const models_swipe = "PRZESUŃ ABY ODKRYĆ";

export const process_title = "Proces Budowy";
export const process_subtitle = "Od Wizji do Rzeczywistości";
export const process_step1_title = "Konsultacja";
export const process_step1_desc = "Rozpocznij swoją podróż z naszym zespołem projektowym. Zbadamy Twoją wizję, preferencje i wymagania dotyczące wydajności.";
export const process_step2_title = "Konfiguracja";
export const process_step2_desc = "Wybierz każdy detal—od wzorów splotu węglowego po materiały wnętrza. Wizualizuj swoją budowę w czasie rzeczywistym.";
export const process_step3_title = "Inżynieria";
export const process_step3_desc = "Nasi inżynierowie optymalizują każdy komponent zgodnie z Twoimi specyfikacjami, zapewniając szczytową wydajność i niezawodność.";
export const process_step4_title = "Produkcja";
export const process_step4_desc = "Mistrzowie rzemiosła ożywiają Twoją wizję, ręcznie budując każdy komponent z precyzją i troską.";
export const process_step5_title = "Dostawa";
export const process_step5_desc = "Doświadcz momentu, gdy Twoje arcydzieło przybywa. Kompleksowe przekazanie i dożywotnie wsparcie w cenie.";

export const process_label = "Proces Budowy";
export const process_headline1 = "Od Surowego Węgla";
export const process_headline2 = "do Gotowego Dzieła.";
export const process_body = "Każdy build ORVANTHE przebiega według skrupulatnego sześcioetapowego procesu. Bez skrótów. Bez outsourcingu. Każdy pojazd to wyjątkowy wyraz precyzji i rzemiosła.";
export const process_start_build = "Rozpocznij Swój Build";
export const process_hours = "Godzin na Build";
export const process_craftsmen = "Mistrzów Rzemiosła";
export const process_inspection = "Punktowa Inspekcja";
export const process_warranty = "Gwarancja Strukturalna";

export const contact_title = "Rozpocznij Swoją Budowę";
export const contact_subtitle = "Stwórzmy Coś Niezwykłego";
export const contact_form_name = "Imię i Nazwisko";
export const contact_form_email = "Adres E-mail";
export const contact_form_phone = "Numer Telefonu";
export const contact_form_interest = "Interesuję Się";
export const contact_form_interest_new = "Nowa Budowa";
export const contact_form_interest_custom = "Projekt Niestandardowy";
export const contact_form_interest_carbon = "Dział Carbon";
export const contact_form_interest_atelier = "Atelier Wnętrz";
export const contact_form_interest_inquiry = "Zapytanie Ogólne";
export const contact_form_message = "Opowiedz Nam o Swojej Wizji";
export const contact_form_submit = "Wyślij Zapytanie";
export const contact_form_submitting = "Wysyłanie...";
export const contact_form_success = "Dziękujemy! Skontaktujemy się w ciągu 24 godzin.";
export const contact_form_error = "Coś poszło nie tak. Spróbuj ponownie.";
export const contact_form_required = "To pole jest wymagane";
export const contact_form_email_invalid = "Wprowadź prawidłowy adres e-mail";

export const contact_configure_label = "Konfiguruj";
export const contact_headline1 = "ROZPOCZNIJ SWÓJ";
export const contact_headline2 = "BUILD";
export const contact_body = "Wybierz pakiet, wybierz pojazd, a my stworzymy coś niepowtarzalnego.";
export const contact_step_package = "Pakiet";
export const contact_step_vehicle = "Pojazd";
export const contact_step_details = "Szczegóły";
export const contact_continue = "Kontynuuj";
export const contact_back = "Wstecz";
export const contact_edit = "Edytuj";
export const contact_change = "Zmień";
export const contact_select_brand = "Wybierz Markę *";
export const contact_select_model = "Wybierz Model *";
export const contact_enter_vehicle = "Wpisz Swój Pojazd *";
export const contact_timeline_label = "Preferowany Termin";
export const contact_timeline_placeholder = "Wybierz termin";
export const contact_timeline_asap = "Jak najszybciej";
export const contact_timeline_1_3 = "1–3 miesiące";
export const contact_timeline_3_6 = "3–6 miesięcy";
export const contact_timeline_6_12 = "6–12 miesięcy";
export const contact_timeline_exploring = "Tylko rozglądam się";
export const contact_additional_details = "Dodatkowe Szczegóły";
export const contact_message_placeholder = "Opowiedz nam o swojej wizji — preferencje kolorystyczne, konkretne modyfikacje, inspiracje...";
export const contact_submit_inquiry = "Wyślij Zapytanie";
export const contact_processing = "Przetwarzanie...";
export const contact_success = "Dziękujemy! Skontaktujemy się w ciągu 24 godzin, aby omówić Twój build.";
export const contact_error = "Proszę wypełnić wszystkie wymagane pola i spróbować ponownie.";
export const contact_location = "Warszawa, PL";

export const news_title = "Najnowsze Wiadomości";
export const news_subtitle = "Aktualności z Veragua";
export const news_read_more = "Czytaj Więcej";

export const social_title = "Śledź Naszą Podróż";
export const social_subtitle = "Za Kulisami";
export const social_view_post = "Zobacz Post";

export const footer_tagline = "Doskonałość Inżynieryjna. Wydajność Bez Kompromisów.";
export const footer_company = "Firma";
export const footer_company_about = "O Nas";
export const footer_company_careers = "Kariera";
export const footer_company_press = "Prasa";
export const footer_company_contact = "Kontakt";
export const footer_models = "Modele";
export const footer_models_hypercar = "Seria Hypercar";
export const footer_models_gt = "Kolekcja GT";
export const footer_models_roadster = "Linia Roadster";
export const footer_models_limited = "Edycje Limitowane";
export const footer_services = "Usługi";
export const footer_services_carbon = "Dział Carbon";
export const footer_services_atelier = "Atelier Wnętrz";
export const footer_services_bespoke = "Projekty na Zamówienie";
export const footer_services_support = "Wsparcie Właścicieli";
export const footer_legal = "Prawne";
export const footer_legal_privacy = "Polityka Prywatności";
export const footer_legal_terms = "Warunki Usługi";
export const footer_legal_cookies = "Polityka Cookies";
export const footer_copyright = "© 2024 Veragua. Wszelkie prawa zastrzeżone.";
export const footer_powered = "Kreator Stron";

export const footer_copyright_text = "© ORVANTHE 2025. WSZELKIE PRAWA ZASTRZEŻONE.";
export const footer_tagline_short = "Wykonane z Węgla. Zbudowane Bez Kompromisów.";

export const about_hero_title = "O Veragua";
export const about_hero_subtitle = "Projektowanie Przyszłości Wydajności";
export const about_story_title = "Nasza Historia";
export const about_story_text = "Założona na zasadzie, że kompromis nie ma miejsca w doskonałości motoryzacyjnej, Veragua wyłoniła się z wizji przedefiniowania tego, co możliwe. Nie budujemy samochodów—projektujemy doświadczenia wykraczające poza konwencjonalne granice.";
export const about_philosophy_title = "Nasza Filozofia";
export const about_philosophy_text = "Każda decyzja, każdy komponent, każdy detal jest kierowany niezachwianym zaangażowaniem w perfekcję. Wierzymy w czystość celu, elegancję inżynierii i nieustanne dążenie do wydajności.";
export const about_craftsmanship_title = "Rzemiosło";
export const about_craftsmanship_text = "Nasi mistrzowie rzemiosła łączą tradycyjne techniki z najnowocześniejszą technologią. Każdy pojazd jest budowany ręcznie, zapewniając, że każda powierzchnia, każdy szew, każdy komponent spełnia nasze rygorystyczne standardy.";
export const about_vision_title = "Nasza Wizja";
export const about_vision_text = "Wyobrażamy sobie przyszłość, w której wydajność i zrównoważony rozwój współistnieją, gdzie technologia wzbogaca doświadczenie jazdy bez jego umniejszania, i gdzie każda podróż jest wyrazem motoryzacyjnej artystyki.";

export const about_hero_subtitle_short = "Gdzie precyzyjna inżynieria spotyka artystyczną wizję";
export const about_hero_scroll = "PRZEWIŃ";
export const about_story_heading = "Początki";
export const about_story_p1 = "Założona w 2018 roku, ORVANTHE wyłoniła się z jednej wizji: przekroczenia granic między inżynierią motoryzacyjną a sztuką piękną. To, co zaczęło się jako projekt pasji w skromnym warsztacie, przekształciło się w globalnie uznane atelier doskonałości motoryzacyjnej.";
export const about_story_p2 = "Nasz założyciel, kierowany obsesją na punkcie perfekcji i głębokim szacunkiem dla dziedzictwa motoryzacyjnego, zebrał zespół mistrzów rzemiosła, inżynierów i projektantów, którzy podzielali te same bezkompromisowe standardy. Razem zapoczątkowali nowe podejście do personalizacji samochodów — takie, które traktuje każdy pojazd jako płótno dla innowacji.";
export const about_story_p3 = "Każde dzieło ORVANTHE rodzi się z setek godzin skrupulatnego planowania, skanowania 3D i ręcznego wykończenia. Nie modyfikujemy po prostu pojazdów; rekonstruujemy je na poziomie molekularnym, wyobrażając sobie na nowo, co jest możliwe, gdy artyzm spotyka precyzję inżynieryjną.";
export const about_story_est = "Zał. 2018";
export const about_story_since = "PRECYZJA OD PIERWSZEGO DNIA";

export const about_craft_heading = "W Liczbach";
export const about_craft_body = "Precyzja, poświęcenie i doskonałość zmierzone";
export const about_craft_quote = "Nie budujemy samochodów. Rzeźbimy marzenia z węgla i stali, tworząc inżynieryjną poezję poruszającą się z prędkością 320 km/h.";
export const about_craft_manifesto = "MANIFEST ORVANTHE";
export const about_craft_stat1_label = "Godzin na Build";
export const about_craft_stat1_desc = "Skrupulatna dbałość o każdy detal";
export const about_craft_stat2_label = "Mistrzów Rzemiosła";
export const about_craft_stat2_desc = "Dziesięciolecia łącznego doświadczenia";
export const about_craft_stat3_label = "Tolerancja Precyzji";
export const about_craft_stat3_desc = "Inżynieria na poziomie mikroskopowym";
export const about_craft_stat4_label = "Ręcznie Wykończone";
export const about_craft_stat4_desc = "Bez skrótów, bez kompromisów";

export const about_phil_heading = "Nasza Filozofia";
export const about_phil_body = "Cztery zasady kierujące każdą decyzją, każdym projektem, każdym detalem";
export const about_phil_p1_title = "Bezkompromisowa Wizja";
export const about_phil_p1_desc = "Odmawiamy akceptowania ograniczeń. Każdy projekt zaczyna się od pytania: co jeśli moglibyśmy to zrobić lepiej? To nieustanne dążenie do perfekcji napędza każdą decyzję, każdy pomiar, każde wykończenie.";
export const about_phil_p2_title = "Rzemiosło Artysanów";
export const about_phil_p2_desc = "W erze automatyzacji, championujemy ludzki dotyk. Nasi mistrzowie rzemiosła spędzają lata doskonaląc swoje umiejętności, zapewniając, że każda powierzchnia, każdy szew, każdy detal odzwierciedla najwyższe standardy jakości.";
export const about_phil_p3_title = "Innowacja Bez Kompromisów";
export const about_phil_p3_desc = "Przyjmujemy najnowocześniejszą technologię — skanowanie 3D, inżynierię włókna węglowego, zaawansowaną aerodynamikę — ale nigdy kosztem duszy. Technologia służy artystyce, nie odwrotnie.";
export const about_phil_p4_title = "Partnerstwo z Klientem";
export const about_phil_p4_desc = "Każde dzieło ORVANTHE to współpraca. Słuchamy, doradzamy, dopracowujemy. Twoja wizja staje się naszą misją, i razem tworzymy coś, co przekracza oczekiwania.";

export const about_vision_heading = "Patrząc w Przyszłość";
export const about_vision_p1 = "Przyszłość ORVANTHE nie dotyczy wolumenu — chodzi o wpływ. Nigdy nie obniżymy naszych standardów, aby skalować produkcję. Zamiast tego inwestujemy w materiały nowej generacji, zaawansowaną aerodynamikę i zrównoważone praktyki inżynieryjne, które honorują zarówno wydajność, jak i odpowiedzialność.";
export const about_vision_p2 = "Nasza wizja wykracza poza indywidualne buildy. Tworzymy dziedzictwo innowacji, szkolimy następne pokolenie mistrzów rzemiosła i przesuwamy granice tego, co możliwe, gdy sztuka i inżynieria się zbiegają.";
export const about_vision_p3 = "Każdy pojazd ORVANTHE jest stwierdzeniem: że doskonałości nie można pośpieszyć, że piękno wymaga cierpliwości, i że prawdziwy luksus mierzy się nie ceną, ale dążeniem do perfekcji.";
export const about_vision_sustain_title = "Zrównoważona Innowacja";
export const about_vision_sustain_desc = "Produkcja neutralna węglowo do 2026 roku";
export const about_vision_academy_title = "Akademia Rzemiosła";
export const about_vision_academy_desc = "Szkolenie następnego pokolenia artysanów";
export const about_vision_materials_title = "Materiały Przyszłości";
export const about_vision_materials_desc = "Pionierskie kompozyty klasy lotniczej";
export const about_vision_statement = "To nie jest stylizacja. To jest rekonstrukcja.";

export const back_to_top = "Powrót na górę";

export const common = {
  nav: {
    carbon: 'CARBON',
    builds: 'REALIZACJE',
    atelier: 'ATELIER',
    performance: 'PERFORMANCE',
  },
  contact: {
    hero: {
      eyebrow: 'Skontaktuj się',
      title: 'Kontakt',
      subtitle: 'Skontaktuj się, aby omówić swoją wizję, umówić wizytę w studio lub zapytać o nasze usługi.'
    },
    info: {
      title: 'Informacje o Studio',
      address: {
        label: 'Adres',
        value: 'Aleje Jerozolimskie 123',
        subvalue: '00-001 Warszawa, Polska'
      },
      email: {
        label: 'Email',
      },
      phone: {
        label: 'Telefon',
      },
      hours: {
        label: 'Godziny Otwarcia',
        value: 'Poniedziałek – Piątek: 9:00 – 18:00',
        subvalue: 'Sobota: Tylko po Umówieniu'
      },
      social: 'Śledź Nas'
    },
    visit: {
      title: 'Umów Wizytę w Studio',
      description: 'Doświadcz ORVANTHE osobiście. Zwiedzaj nasze studio, poznaj nasz zespół i odkryj bibliotekę materiałów oraz ukończone projekty.',
      benefit1: 'Prywatna konsultacja z naszym zespołem projektowym',
      benefit2: 'Praktyczny wybór materiałów i wykończeń',
      benefit3: 'Zobacz bieżące projekty w trakcie realizacji',
      cta: 'Zarezerwuj Wizytę',
      form: {
        title: 'Zarezerwuj Wizytę w Studio',
        subtitle: 'Wybierz preferowaną datę i godzinę. Potwierdzimy dostępność w ciągu 24 godzin.',
        name: 'Imię i Nazwisko',
        email: 'Adres Email',
        phone: 'Numer Telefonu',
        date: 'Preferowana Data',
        time: 'Preferowana Godzina',
        visitors: 'Liczba Gości',
        selectTime: 'Wybierz godzinę',
        notes: 'Dodatkowe Uwagi',
        notesPlaceholder: 'Jakieś szczególne zainteresowania lub pytania?',
        submit: 'Potwierdź Rezerwację',
        submitting: 'Wysyłanie...',
        validation: 'Proszę wypełnić wszystkie wymagane pola.',
        success: {
          title: 'Wizyta Zaplanowana',
          message: 'Twoja wizyta w studio została potwierdzona. Wkrótce wyślemy Ci email z potwierdzeniem.'
        }
      }
    },
    form: {
      title: 'Wyślij Nam Wiadomość',
      subtitle: 'Zazwyczaj odpowiadamy w ciągu 24 godzin.',
      name: 'Imię i Nazwisko',
      namePlaceholder: 'Jan Kowalski',
      email: 'Adres Email',
      emailPlaceholder: 'jan@example.com',
      phone: 'Numer Telefonu',
      phonePlaceholder: '+48 123 456 789',
      subject: 'Temat',
      subjectPlaceholder: 'Wybierz temat',
      subjects: {
        general: 'Zapytanie Ogólne',
        carbon: 'Dział Carbon',
        atelier: 'Atelier Wnętrz',
        performance: 'Linia Performance',
        build: 'Zapytanie o Projekt',
        partnership: 'Możliwość Współpracy'
      },
      message: 'Wiadomość',
      messagePlaceholder: 'Opowiedz nam o swoim projekcie lub zapytaniu...',
      characters: 'znaków',
      submit: 'Wyślij Wiadomość',
      sending: 'Wysyłanie...',
      validation: 'Proszę wypełnić wszystkie wymagane pola.',
      maxLength: 'Wiadomość nie może przekraczać 500 znaków.',
      success: {
        title: 'Wiadomość Wysłana',
        message: 'Dziękujemy za kontakt. Otrzymaliśmy Twoją wiadomość.',
        response: 'Nasz zespół odpowie w ciągu 24 godzin.'
      }
    },
    map: {
      title: 'Znajdź Nasze Studio',
      subtitle: 'Zlokalizowane w sercu Warszawy',
      location: 'Lokalizacja Studio'
    },
    faq: {
      title: 'Najczęściej Zadawane Pytania',
      subtitle: 'Szybkie odpowiedzi na częste pytania',
      q1: {
        question: 'Jaki jest typowy czas realizacji projektu?',
        answer: 'Większość projektów trwa 8-16 tygodni od wstępnej konsultacji do dostawy, w zależności od złożoności i dostępności materiałów. Usługi ekspresowe są dostępne dla wybranych pakietów.'
      },
      q2: {
        question: 'Czy wysyłacie międzynarodowo?',
        answer: 'Tak, wysyłamy na cały świat. Wszystkie komponenty carbonowe są starannie pakowane i ubezpieczone. Wsparcie instalacyjne można zorganizować przez naszą sieć partnerów.'
      },
      q3: {
        question: 'Czy mogę odwiedzić studio bez umówienia?',
        answer: 'Zalecamy wcześniejsze umówienie wizyty, aby zapewnić dostępność naszego zespołu i kompleksową prezentację oraz konsultację.'
      },
      q4: {
        question: 'Jakie metody płatności akceptujecie?',
        answer: 'Akceptujemy przelewy bankowe, karty kredytowe i kryptowaluty. Wymagana jest zaliczka w wysokości 50% na rozpoczęcie prac, pozostała kwota płatna po zakończeniu.'
      },
      q5: {
        question: 'Czy oferujecie usługi instalacji?',
        answer: 'Tak, profesjonalna instalacja jest dostępna w naszym studio lub przez naszą certyfikowaną sieć partnerów w całej Europie i poza nią.'
      },
      q6: {
        question: 'Jaką gwarancję zapewniacie?',
        answer: 'Wszystkie produkty ORVANTHE objęte są 2-letnią gwarancją obejmującą wady produkcyjne. Komponenty carbonowe mają dożywotnią gwarancję strukturalną.'
      },
      more: 'Masz jeszcze pytania?',
      email: 'Napisz do nas bezpośrednio'
    }
  }
};
